import axios from '../config.js';
const resource = '/user/schedule';

export default {
  get(id='') {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.get(`${resource}${id ? `/${id}`: ''}`);
  },
  create(payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.post(resource, payload);
  },
  delete(id) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.delete(`${resource}/${id}`);
  },
};